// src/pages/EmailReject.jsx
import React from 'react';
import { Box, Typography, useTheme, List, ListItem, ListItemText } from '@mui/material';
import Footer from '../components/Footer';

function EmailReject() {
  const theme = useTheme();

  return (
    <Box
    sx={{
      minHeight: '100vh',         // 화면을 꽉 채우고 싶다면 사용
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 4,
      py: 3,
      color: theme.palette.text.primary,
      bgcolor: theme.palette.background.default,
      mt: {xs:10,sm:3,md:-3},
      width: {xs:'90%',sm:'90%',md:'80%'},
      mx: 'auto'
    }}
    >
      <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
        이메일무단수집거부
      </Typography>

      <Typography variant="h6" align="center" paragraph>
        본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단 수집되는 것을 거부합니다.<br/> 이를 위반시 『정보통신망 이용촉진 및 정보보호등에 관한 법률』등에 의해 처벌 받을 수 있습니다.
      </Typography>

      <Typography variant="body1" align="center" paragraph>
        <hr />
      </Typography>

      <Typography variant="h5" align="flex-start" sx={{ fontWeight: 'bold' ,mt: -2 }}>
        제50조의2 (전자우편주소의 무단 수집행위 등 금지)
      </Typography>

      <Typography variant="body1" align="flex-start" sx={{ fontWeight: 'bold',mt: -2, mb: 2, pl: 4 }}>
      - 누구든지 인터넷 홈페이지 운영자 또는 관리자의 사전 동의 없이 인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.
      <br/>
      - 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매·유통하여서는 아니된다.
      <br/>
      - 누구든지 제1항 및 제2항의 규정에 의하여 수집·판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보 전송에 이용하여서는 아니된다.
      </Typography>
      <Footer />
    </Box>
  );
}

export default EmailReject;
